import { FormGroup, FormControl } from '@angular/forms';
import { FormLaudoComponent } from '../form-laudo.component';
import { LaudoInput } from 'src/app/models/laudo-input';

export const alterarLocalRealizacao = (element:LaudoInput, values:any[], parent:FormLaudoComponent) => {

    let childElements = values && values.length>0 ? values : [
        'cepVistoria',
        'logradouroVistoria',
        'numeroVistoria',
        'estadoVistoria',
        'bairroVistoria',
        'municipioVistoria',
        'complementoVistoria',
    ];

    element.control.valueChanges.subscribe(r => {
        if (parent.step && parent.step.form) {
            let form = parent.step.form as FormGroup;
            switch (r) {
                case 'outro':
                    childElements.forEach(e => {
                        let c = form.get(e);
                        if(c) {
                            c.patchValue('');
                            c.enable();
                        }
                    })
                    break;

                case 'cliente':
                    form.patchValue({
                        cepVistoria: '29118530',
                        logradouroVistoria: '29118530',
                        numeroVistoria: '29118530',
                        estadoVistoria: '29118530',
                        bairroVistoria: '29118530',
                        municipioVistoria: '29118530',
                        complementoVistoria: '29118530',
                    });
                    childElements.forEach(e => {
                        let c = form.get(e);
                        if(c) {
                            c.disable();
                        }
                    });
                    break;

                case 'unidade':
                    form.patchValue({
                        cepVistoria: '29118666',
                        logradouroVistoria: '29118666',
                        numeroVistoria: '29118666',
                        estadoVistoria: '29118666',
                        bairroVistoria: '29118666',
                        municipioVistoria: '29118666',
                        complementoVistoria: '29118666',
                    });
                    childElements.forEach(e => form.get(e).disable());
                    break;

                default:
                    break;
            }
        }
    })
}